// extracted by mini-css-extract-plugin
module.exports = {"EditButton":"style_EditButton__HmHjP","text":"style_text__31Ie_"};